import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PhotoService} from '../../../photo/services/photo.service';
import {CategoryService} from '../../../category/services/category.service';
import {Photo} from '../../../../shared/models/cameralla-photo.model';
import {ActivatedRoute, Router} from '@angular/router';
import {CategoryModel} from '../../../../shared/models/cameralla-category.model';
import {debounceTime} from 'rxjs/operators';
import {fromEvent, Subscription} from 'rxjs';
import * as $ from 'jquery';
import * as _ from 'lodash';
import * as moment from 'moment';
import {PhotoOrder} from '../../../../shared/models/cameralla-photo-order.model';
import {CamerallaAuthService} from '../../../../shared/services/authentication-services/cameralla-auth.service';
import {NgxMasonryOptions} from 'ngx-masonry';
import {PhotoCardComponent} from '../../../../shared/components/photo-card/photo-card.component';
import AppShareHelper from '../../../../shared/utils/helper';

@Component({
    templateUrl: './search-page.component.html'
})
export class SearchPageComponent implements OnInit, AfterViewInit, OnDestroy {
    limit = 10;
    skip = 0;
    photos: Photo[] = [];
    previousPhotos: Photo[] = [];
    newPhotos = 0;
    photoOrder: PhotoOrder;
    search_photos: Photo[] = [];
    lazyLoadTriggered = false;
    totalPhotos: number;
    filters: CategoryModel[] = [];
    searchTerm = '';
    defaultRatingType = 'general';
    selectedFilters = [];
    selectedTimeFrame: {
        from: string,
        to: string,
    };
    _srolling: Subscription;

    @ViewChild('photoZone') photoZone;
    constructor(private photoService: PhotoService, private categoryService: CategoryService, private router: Router, private route: ActivatedRoute, private userAuth: CamerallaAuthService) {
        this.photoOrder = new PhotoOrder();

        this.photoService.subscribe(PhotoService.SET_PHOTOS_FILTER, () => {
            this.skip = 0;
            const start = this.skip;
            const end = this.skip + this.limit;
            this.photos = this.processFilter(this.search_photos).slice(start, end);
            this.newPhotos = this.photos.length - AppShareHelper.checkLoadedPhotos(this.previousPhotos, this.photos);
            this.updateMansoryLayout();
        });

        this.photoService.subscribe(PhotoService.LAZY_LOADING_PHOTOS, (skip) => {
            const start = this.skip;
            if (start < this.totalPhotos) {
                const end = this.skip + this.limit;
                const addMore = this.processFilter(this.search_photos).slice(start, end);
                const dif = this.photos.length;
                this.photos = [...this.photos, ...addMore];
                this.newPhotos += this.photos.length - dif;

                return this.updateMansoryLayout();
            }

            return this.lazyLoadTriggered = false;
        });

        setTimeout(function () {
            $('.dropdown-menu').click(function (e) {
                e.stopPropagation();
            });
        }, 0);
    }

    public renderImageOptions: NgxMasonryOptions = {
        transitionDuration: '1s',
        itemSelector: '.grid-item',
        horizontalOrder: true
    };

    ngOnInit() {
        this.getCategories().then(
            resolve => {
                this.filters = resolve;
                // reset all filters
                this.resetFilters();

                // get keyword from query params
                this.route.queryParams.subscribe(
                    params => {
                        if (params['keyword']) {
                            this.searchTerm = params['keyword'];

                            this.getPhotos(this.searchTerm).then(
                                publish_data => {
                                    this.search_photos = publish_data['data'];
                                    this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
                                    this.lazyLoadTriggered = publish_data['isLazyLoad'];
                                    this.totalPhotos = publish_data['total_amount'];
                                },
                                reject_error => {
                                    console.log(reject_error);
                                }
                            );
                        } else {
                            console.log('not found');
                        }
                    }
                );
            },
            reject => console.log(reject)
        );

        $('.dropdown-menu').click(function (e) {
            e.stopPropagation();
        });
    }

    getCategories() {
        return this.categoryService.getCategories().toPromise().then(
            response => {
                if (response['Data']) {
                    return Promise.resolve(response['Data']);
                }
            },
            error => {
                console.log('Get category API error ' + error);

                return Promise.reject(error);
            }
        );
    }

    resetFilters() {
        this.limit = 10;
        this.skip = 0;
        this.selectedFilters = [];
        this.lazyLoadTriggered = true;
    }

    getPhotos(searchTerm: string) {
        return this.photoService.searchPhotos(searchTerm, this.userAuth.getLocalUserInfo()['id']).toPromise().then(
            response => {
                const publish_data = {
                    data: [],
                    isLazyLoad: false,
                    total_amount: 0
                };

                if (response['Data'].length) {
                    publish_data.data = response['Data'];
                    publish_data.isLazyLoad = true;
                    publish_data.total_amount = response['Data'].length;

                    return Promise.resolve(publish_data);
                }

                return Promise.resolve(publish_data);
            },
            error => {
                console.log('SEARCH API ERROR ' + error);

                return Promise.reject(error);
            }
        );
    }

    processFilter(photos: Photo[]) {
        let results = photos;
        const categoryId_arry = this.selectedFilters.map(el => el.value);

        if (categoryId_arry.length) {
            results = _.filter(results, function (photo) {
                return categoryId_arry.includes(photo.categoryId);
            });
        }

        this.selectedTimeFrame = this.photoService.processTimeFrame(this.photoOrder.selectedTimeFrame.value);
        const that = this;
        results = _.filter(results, function (photo) {
            const date = moment(photo.create_at, 'YYYY-MM-DD');
            const from = moment(that.selectedTimeFrame.from, 'YYYY-MM-DD');
            const to = moment(that.selectedTimeFrame.to, 'YYYY-MM-DD');
            let isBetween: boolean;
            switch (that.photoOrder.selectedTimeFrame.value) {
                case 'today' :
                    return isBetween = moment(date).isSame(from, 'day');
                case 'allTime' :
                    return isBetween = moment(date).isSameOrBefore(from, 'day');
                default:
                    return isBetween = moment(date).isSameOrAfter(from, 'day') && moment(date).isSameOrBefore(to, 'day');
            }
        });

        let orderBy = this.photoOrder.selectedBrowse.value;

        if (orderBy === 'starsCount') {
            orderBy = 'ratings.' + this.defaultRatingType;
        }

        if (orderBy) {
            results.map(each => {
                if (!each.ratings) {
                    each.ratings = Photo.getDefaultRating({});
                }
            });

            results = _.orderBy(results, orderBy, this.photoOrder.selectedOrder.value.toLowerCase());
        }

        return results;
    }

    selectFilter(category: CategoryModel) {
        this.previousPhotos = this.photos;
        this.lazyLoadTrigger();
        const selected_tag = {display: category.name, value: category.id};

        const isSelected = this.selectedFilters.some(each => {
            return each['value'] === selected_tag['value'];
        });

        if (!isSelected) {
            this.selectedFilters.push({display: category.name, value: category.id});
            this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
        }
    }

    search() {
        if (this.searchTerm) {
            return this.router.navigate(['/search'], {queryParams: {keyword: this.searchTerm}});
        }

        return this.router.navigate(['/']);
    }

    selectBrowse(order: { name: string, value: string }) {
        localStorage.setItem('selectedBrowse', JSON.stringify(order));
        this.lazyLoadTrigger();
        this.photoOrder.selectedBrowse = order;
        this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
    }

    selectOrder(order: { name: string, value: string }) {
        localStorage.setItem('selectedOrder', JSON.stringify(order));
        this.lazyLoadTrigger();
        this.photoOrder.selectedOrder = order;
        this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
    }

    selectRating(rating: { name: string, value: string }) {
        localStorage.setItem('selectedRating', JSON.stringify(rating));
        this.lazyLoadTrigger();
        this.photoOrder.selectedRating = rating;
        this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
    }

    selectTime(type) {
        localStorage.setItem('selectedTimeFrame', JSON.stringify(type));
        this.lazyLoadTrigger();
        this.photoOrder.selectedTimeFrame = type;
        this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
    }

    removeFilter() {
        this.previousPhotos = this.photos;
        this.photos = [];
        this.lazyLoadTrigger();
        this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
    }

    isSelected(filter) {
        for (const each of this.selectedFilters) {
            if (each['value'] === filter['id']) {
                return true;
            }
        }

        return false;
    }

    trackByFn(index, item) {
        return item.id;
    }

    ngAfterViewInit() {
        this._srolling = fromEvent(document, 'scroll').pipe(debounceTime(300))
            .subscribe(
                events => {
                    const bottom = $(document).height();
                    const scrollPosition = Math.ceil($(window).scrollTop() + $(window).height());
                    if (this.lazyLoadTriggered) {
                        if (scrollPosition >= bottom) {
                            this.skip += this.limit;
                            return this.photoService.publish(PhotoService.LAZY_LOADING_PHOTOS, this.skip);
                        }
                        return '';
                    }
                    return '';
                }
            );
    }

    ngOnDestroy() {
        this.skip = 0;
        this._srolling.unsubscribe();
        this.photoService.unsubscribe(PhotoService.SET_PHOTOS_FILTER);
        this.photoService.unsubscribe(PhotoService.LAZY_LOADING_PHOTOS);
    }

    resetPhotosList(searchKey: string) {
        const searchElement = document.getElementById('search_field');
        const isFocus = document.activeElement === searchElement;

        if (!searchKey && !isFocus) {
            this.resetFilters();
            return this.photoService.publish(PhotoService.SET_PHOTOS_FILTER);
        }

        return '';
    }

    onNotify(lazyLoadReady: boolean) {
        this.lazyLoadTriggered = lazyLoadReady;
    }

    lazyLoadTrigger() {
        this.lazyLoadTriggered = true;
        PhotoCardComponent.photosLoaded = 0;
    }

    public updateMansoryLayout() {
        setTimeout(() => {
            this.photoZone._msnry.reloadItems();
            this.photoZone._msnry.layout();
        }, 300);

        PhotoCardComponent.numberOfNewPhotoLoaded = 0;

        this.photoZone._msnry.reloadItems();
        this.photoZone._msnry.layout();
    }
}
